import { useSubscription } from '@apollo/react-hooks';

import { graphqlSchema } from '../../../services/graphql.schema';
import { useCurrentUser } from '../../../contexts/CurrentUserContext';

function AccountSubscriptionManager(): null {
    const { recallCurrentUser } = useCurrentUser();

    useSubscription(graphqlSchema.FISCALPOP.STRIPE.SUBSCRIPTIONS.billingAccountUpdated, {
        onSubscriptionData: ({ subscriptionData }) => {
            console.log('[AccountSubscriptionManager] billingAccountUpdated', subscriptionData.data?.billingAccountUpdated);
            recallCurrentUser();
        }
    });

    useSubscription(graphqlSchema.FISCALPOP.STRIPE.SUBSCRIPTIONS.billingAccountSubscriptionUpdated, {
        onSubscriptionData: ({ subscriptionData }) => {
            console.log('[AccountSubscriptionManager] billingAccountSubscriptionUpdated', subscriptionData.data?.billingAccountSubscriptionUpdated);
            recallCurrentUser();
        }
    });

    useSubscription(graphqlSchema.FISCALPOP.STRIPE.SUBSCRIPTIONS.speiPaymentRequested, {
        onSubscriptionData: ({ subscriptionData }) => {
            console.log('[AccountSubscriptionManager] speiPaymentRequested', subscriptionData.data?.speiPaymentRequested);
            recallCurrentUser();
        }
    });

    return null;
}

export default AccountSubscriptionManager;
